import * as Yup from 'yup'

export const addCustomerValidationSchema = Yup.object().shape({
  name: Yup.string().required('Required').min(3, 'Minimum 3 symbols long'),
})
